import { render, staticRenderFns } from "./ImageHotspotsPanel.vue?vue&type=template&id=785ba078&scoped=true"
import script from "./ImageHotspotsPanel.vue?vue&type=script&lang=js"
export * from "./ImageHotspotsPanel.vue?vue&type=script&lang=js"
import style0 from "./ImageHotspotsPanel.vue?vue&type=style&index=0&id=785ba078&prod&lang=scss&scoped=true"
import style1 from "./ImageHotspotsPanel.vue?vue&type=style&index=1&id=785ba078&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ba078",
  null
  
)

export default component.exports